/**
 * ============================================================================
 * INSPECTION HELPER UTILITIES
 * ============================================================================
 * Pure utility functions for working with inspection data
 * Version: v3.10.0-CLEAR-MAP
 */

/**
 * Extract additional notes from inspection
 * Handles multiple note formats (Quick Shot, Regular Mode, etc.)
 */
export const extractAdditionalNotes = (inspection) => {
  // First check if there's a dedicated additional_notes field
  if (inspection.additional_notes) {
    return inspection.additional_notes;
  } 
  
  // Check main_page_voice_notes field (this is where regular mode notes are stored)
  if (inspection.main_page_voice_notes) {
    return inspection.main_page_voice_notes;
  }
  
  // Then check the notes field for Quick Shot format
  if (inspection.notes) {
    const notesText = inspection.notes;
    
    // Quick Shot format: "Additional Notes: content"
    const additionalNotesMatch = notesText.match(/Additional Notes: (.+)/);
    if (additionalNotesMatch) {
      return additionalNotesMatch[1];
    }
    
    // Regular mode format: check if notes don't contain "Submitted by:" (meaning it's just user notes)
    if (!notesText.includes('Submitted by:') && !notesText.includes('Mode:')) {
      return notesText;
    }
  }
  
  return '';
};

